module.exports = __webpack_public_path__ + "static/heading-bdbd17eca1d46c7e914f4f3c8411d013.png";